import { useEffect, useState } from "react";
import Loader from "../../Loader/Loader";
import "./style.css";
import DownloadContainer from "./DownloadContainer";
import { CREATED, DELETED } from "../../../utils/constants";
import HistoryItem from "./HistoryItem";

const AliaseSubIdHistory = ({ diData, loading = false }) => {
  const [loader, setLoader] = useState(true);
  const [subIdAliaseHistory, setsubIdAliaseHistory] = useState([]);
  const getAliaseSubIdHistory = async () => {
    setLoader(true);
    try {
      const subIdAliaseHistory = [];

      // Process Active Records (Created)
      diData?.digital_identity?.sub_identities?.map(
        ({ type, value, created_datetime }) => {
          subIdAliaseHistory.push({
            type,
            value,
            identity: "Sub Identity",
            created_datetime,
            action: CREATED,
            dateTime: created_datetime, // "Created" time
            valid_to: null, // No deletion time yet
          });
        }
      );

      diData?.digital_identity?.aliases?.map(
        ({ type, value, created_datetime }) => {
          subIdAliaseHistory.push({
            type,
            value,
            identity: "Alias",
            created_datetime,
            action: CREATED,
            dateTime: created_datetime, // "Created" time
            valid_to: null, // No deletion time yet
          });
        }
      );

      // Process Deleted Records (Deleted)
      Array.isArray(diData?.digital_identity?.deleted_sub_identities) &&
        diData?.digital_identity?.deleted_sub_identities?.map(
          ({ type, value, valid_from, valid_to }) => {
            subIdAliaseHistory.push({
              type,
              value,
              identity: "Sub Identity",
              dateTime: valid_from,
              valid_to,
              action: CREATED,
            });
            subIdAliaseHistory.push({
              type,
              value,
              identity: "Sub Identity",
              dateTime: valid_to,
              action: DELETED,
            });
          }
        );

      Array.isArray(diData?.digital_identity?.deleted_aliases) &&
        diData?.digital_identity?.deleted_aliases?.map(
          ({ type, value, valid_from, valid_to }) => {
            subIdAliaseHistory.push({
              type,
              value,
              identity: "Alias",
              dateTime: valid_from,
              valid_to,
              action: CREATED,
            });
            subIdAliaseHistory.push({
              type,
              value,
              identity: "Alias",
              dateTime: valid_to,
              action: DELETED,
            });
          }
        );

      // Sort subIdAliaseHistory by the most recent valid_from/valid_to date
      subIdAliaseHistory.sort(
        (a, b) =>
          new Date(b.dateTime || b.dateTime) -
          new Date(a.dateTime || a.dateTime)
      );

      setsubIdAliaseHistory(subIdAliaseHistory);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      setsubIdAliaseHistory([]);
    }
  };
  useEffect(() => {
    if (!loading) getAliaseSubIdHistory();
  }, [diData, loading]);
  const hasHistory = subIdAliaseHistory.length > 0;
  return (
    <div className="d-flex flex-column gap-3">
      {hasHistory && (
        <DownloadContainer
          digitalIdentity={diData?.digital_identity}
          history={subIdAliaseHistory}
        />
      )}
      <div className="d-flex flex-column gap-2">
        {loader && <Loader />}
        {!loader &&
          hasHistory &&
          subIdAliaseHistory.map((item) => (
            <HistoryItem
              key={`${item.identity}-${item.type}-${item.value}`}
              item={item}
            />
          ))}
        {!loader && !hasHistory && (
          <h4 className="fs-5 py-2 text-center fw-bold text-danger">
            No history records to show.
          </h4>
        )}
      </div>
    </div>
  );
};

export default AliaseSubIdHistory;
